<template>
    <div :class="classes">
        <el-form class="w-review-info" label-width="120px" v-if="showInfo">
            <el-form-item label="审核ID">{{info.mainInformation.id }}</el-form-item>
            <el-form-item label="提审项">{{ examineItem }}</el-form-item>
            <el-form-item label="提审用户ID">{{ info.mainInformation.openId }}</el-form-item>
            <el-form-item label="用户昵称">{{ info.mainInformation.username }}</el-form-item>
            <el-form-item label="提审时间">{{ info.mainInformation.createdAt }}</el-form-item>
            <el-form-item label="审核状态">
                <span :style="examineStateStyle">
                    {{info.mainInformation.checkStatus | load_status}}
                </span>
            </el-form-item>
            <el-form-item label="审核人">{{ info.mainInformation.checkAdminName }}</el-form-item>
            <el-form-item label="审核时间">{{ info.mainInformation.checkTime }}</el-form-item>
        </el-form>

        <div class="w-examine-state" v-if="showExamine">
            <h3>审核流程</h3>
            <div class="w-state-wrap">
                <div class="w-label w-user-label">
                    <span>用户提交</span>
                </div>
                <div class="w-content">
                    <span>{{ info.mainInformation.username }} {{ info.mainInformation.createdAt }}</span>
                </div>
            </div>

            <div class="w-state-item" v-for="(item, idx) in info.checkDetail" :key="idx">
                <div class="w-state-wrap" v-if="+item.checkStatus === 0">
                    <div class="w-label w-wait-label">
                        <span>{{ state[item.checkStatus] }}（{{+item.checkSteps + 1}}/{{ Object.keys(step).length }}）</span>
                    </div>
                    <div class="w-content">
                        {{ step[+item.checkSteps] }} 
                        <el-popover
                            popper-class="w-review-popover"
                            v-for="(role, idx) in item.role"
                            :key="idx"
                            :title="role.name"
                            placement="top-start"
                            width="200"
                            trigger="hover">
                            <div class="w-popover-content">
                                <p class="w-tips">{{ role.desc }}</p>
                                <p class="w-label">角色成员</p>
                                <template v-if="role.persons && role.persons.length">
                                    <el-tag class="w-tag" size="small" v-for="(person, idx) in role.persons" :key="idx">{{ person }}</el-tag>
                                </template>
                                <span v-else>无</span>
                            </div>
                            <el-button size="mini" slot="reference">{{ role.name }}</el-button>
                        </el-popover>
                    </div>
                </div>

                <div class="w-state-wrap" v-if="+item.checkStatus !== 0">
                    <div class="w-label"
                        :class="[
                            { 'w-pass-label': +item.checkStatus === 1 },
                            { 'w-reject-label': +item.checkStatus <= -1 }
                        ]">
                        <span>
                            {{ state[item.checkStatus] }}
                            <template v-if="+item.checkStatus === 1">
                                （{{ +item.checkSteps}}/{{ Object.keys(step).length }}）
                            </template>
                            <template v-else>
                                （{{ +item.checkSteps + 1 }}/{{ Object.keys(step).length }}）
                            </template>
                        </span>
                    </div>
                    <div class="w-content">
                        <template v-if="+item.checkStatus === 1">
                            {{ step[+item.checkSteps - 1] }}
                        </template>
                        <template v-else>
                            {{ step[+item.checkSteps ] }}
                        </template>
                        {{ item.checkAdminName }}  {{ item.checkTime }}
                    </div>
                </div>

                <div class="w-desc-wrap" v-if="(item.cardCheckInfos && item.cardCheckInfos.length) || item.checkInfo">
                    <template v-if="+item.checkStatus === 1 && +item.hasPriceCheckTags">
                        <el-tag type="info">{{ priceTag[+item.hasPriceCheckTags] }}</el-tag>
                    </template>
                    <template v-if="item.cardCheckInfos.length">
                        <ul class="w-card-wrap" :style="{ columnCount: cardSpan }">
                            <li
                                style="break-inside: avoid; position: relative;"
                                v-for="(card, idx) in item.cardCheckInfos" :key="idx">
                                <el-card class="p-card-item" :class="{[`w-${getExamineType(card.checkStatus)}-border`]: idx === 0 && +card.isCard === 0}">
                                    <el-form>
                                        <el-button-group class="p-examine-title">
                                            <el-button
                                                class="w-state-center"
                                                v-if="+card.checkStatus === 0"
                                                :type="getExamineType(card.checkStatus)"
                                                size="mini">
                                                {{ state[card.checkStatus] }}
                                            </el-button>
                                            <el-button v-else :type="getExamineType(card.checkStatus)" size="mini">{{ state[card.checkStatus] }}</el-button>
                                            <el-button type="plain" size="mini" v-if="+card.checkStatus !== 0">
                                                {{ card.checkAdminName }}
                                                {{ card.checkTime}}
                                            </el-button>
                                        </el-button-group>

                                        <template v-if="card.checkInfo">
                                            <el-form-item
                                                v-for="(item, key) in card.checkInfo"
                                                :key="key"
                                                :label="key">
                                                <div v-if="Array.isArray(item)">
                                                    <el-tag size="small" :key="tag" class="w-tag" type="info" effect="plain" v-for="tag in item">
                                                        {{ tag }}
                                                    </el-tag>
                                                </div>
                                                <span v-else>
                                                    {{ item }}
                                                </span>
                                            </el-form-item>
                                        </template>
                                    </el-form>
                                </el-card>
                            </li>
                        </ul>
                    </template>

                    <el-form v-else-if="item.checkInfo" class="w-desc" label-width="100px">
                        <el-form-item
                            v-for="key in Object.keys(item.checkInfo)"
                            :key="key"
                            :label="key">
                            <div v-if="Array.isArray(item.checkInfo[key])">
                                <el-tag size="small" :key="tag" class="w-tag" type="info" effect="plain" v-for="tag in item.checkInfo[key]">
                                    {{ tag }}
                                </el-tag>
                            </div>
                            <span v-else>
                                {{ item.checkInfo[key] }}
                            </span>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import camelcase from 'camelcase-keys-deep'

const prefix = 'w-examine-info'

export default {
    props: {
        // 展示数据信息源
        obj:{
            type: Object,
        },
        data: {
            type: Object,
            default: () => {}
        },
        // 提审项
        examineItem: {
            type: String,
            default: '摄影投稿'
        },
        // 审核状态
        state: {
            type: Object,
            default: () => ({
                "0": "待审核",
                "1": "审核通过",
                "-1": "已驳回",
                "-2": "已失效或撤回",
                "-3": "已回退"
            })
        },
        // 审核步骤
        step: {
            type: Object,
            default: () => ({
                0: '视觉审核' ,
                1: '价格确认' ,
                2: '价格审批'
            })
        },
        showExamine: {
            type: Boolean,
            default: true
        },
        showInfo: {
            type: Boolean,
            default: true
        },
        cardSpan: {
            type: Number,
            default: 4
        }
    },
    data() {
        return {
            prefix,
            info: {},
            priceTag: { 1: '默认定价', 2: '灵活定价', 3: '修改价格' }
        };
    },
    filters: {
        load_status(val) {
            switch(val) {
                case '0':
                    return '待审核'
                case '1':
                    return '已审核'
                case '-1':
                    return '已驳回'
                case '-2':
                    return '已撤销'
                default:
                    // 默认代码块
            } 
        }
    },
    methods: {
        init() {
        },
        getExamineType(state) {
            let type = 'danger'
            switch (state) {
                case 0:
                    type = 'primary'
                    break;
                case 1:
                    type = 'success'
                    break;
                case -1:
                    type = 'danger'
                    break;
                case -3:
                    type = 'warning'
                    break;
            }

            return type
        },
        getStateStyle(status) {
            let $primary = '#33B3FF'
            let $success = '#27AE60'
            let $danger = '#FF0000'
            let color

            switch (+status) {
                case 0:
                    color = $primary
                    break;
                case 1:
                    color = $success
                    break;
                default:
                    color = $danger
                    break;
            }

            return { color }
        }
    },
    computed: {
        classes() {
            return [prefix]
        },
        examineStateStyle() {
            return this.getStateStyle(this.info.mainInformation.checkStatus)
        }
    },
    created() {
        this.init();
    },
    watch: {
        data: {
            handler(val,oldval) {
                if(val != oldval){
                console.log(this.data,'this.data')
                this.info = camelcase(JSON.parse(JSON.stringify(this.data || {})))
                }
            },
            deep: true,
            immediate: true
        }
    }
};
</script>
<style lang="scss">
$prefixCls: 'w-examine-info';

.#{$prefixCls}{
    .w-review-info {
        padding: 0 40px;
        border-bottom: 1px solid #ddd;
    }

    $primary: #33B3FF;
    $success: #27AE60;
    $warning: #FF9200;
    $danger: #FF0000;
    $info: #979797;

    .w-examine-state {
        padding: 20px 40px 60px;
    }

    .w-state-wrap {
        margin-top: 20px;
        .w-content {
            background-color: #F6F6F6;
            height: 32px;
            line-height: 32px;
            display: inline-block;
            border: 1px solid #D8D8D8;
            padding: 0 20px;
            vertical-align: middle;
        }

        .w-label {
            padding: 0 10px;
            height: 32px;
            line-height: 32px;
            display: inline-block;
            text-align: center;
            color: white;
            vertical-align: middle;
            &.w-user-label {
                background-color: $warning;
                border: 1px solid $warning;
            }
            &.w-reject-label {
                background-color: $danger;
                border: 1px solid $danger;
            }
            &.w-pass-label {
                background-color: $success;
                border: 1px solid $success;
            }
            &.w-wait-label {
                background-color: $primary;
                border: 1px solid $primary;
            }
        }
    }

    .w-desc-wrap {
        border: 1px solid #D8D8D8;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        padding: 20px;
        .w-card-wrap {
            .p-card-item {
                margin-bottom: 20px;
                .p-examine-title {
                    margin-bottom: 20px;
                }

                .el-card__body {
                    border-radius: 4px;
                    min-height: 200px;
                    position: relative;
                }
                &.w-warning-border {
                    .el-card__body {
                        border: 1px solid $warning;
                    }
                }
                &.w-danger-border {
                    .el-card__body {
                        border: 1px solid $danger;   
                    }
                }
                &.w-success-border {
                    .el-card__body {
                        border: 1px solid $success;
                    }
                }
                .w-state-center {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%,-50%);
                }
            }
        }
    }
    .el-form-item {
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 0;
        }
    }

    .w-tag {
        margin-right: 6px;
    }
}
.w-review-popover {
    .w-popover-content {
        .w-label {
            color: #333;
            margin: 10px 0;
        }
    }
}
</style>